// src/api.js
import axios from 'axios'

// API base is provided at build-time via VUE_APP_API_BASE.
function normalizeBase (s) {
  s = (s || '').trim()
  if (!s) return ''
  if (s.indexOf('http://') !== 0 && s.indexOf('https://') !== 0) {
    if (s[0] !== '/') s = '/' + s
  }
  if (s.length > 1 && s[s.length - 1] === '/') s = s.slice(0, -1)
  return s
}

var RAW_BASE = (process.env.VUE_APP_API_BASE || '').trim()
if (process.env.NODE_ENV === 'production' && !RAW_BASE) {
  throw new Error('[api] Missing VUE_APP_API_BASE for production build. Expected: https://app.eddahome.in/api')
}
var BASE = normalizeBase(RAW_BASE || '/api')

var api = axios.create({
  baseURL: BASE,
  withCredentials: false,
  timeout: 20000
})

var LS_TOKEN = 'edda_token'

function getToken () {
  try { return localStorage.getItem(LS_TOKEN) || '' } catch (e) { return '' }
}

// Optional helper for immediate header set/clear
export function setAuthToken (token) {
  if (token) {
    api.defaults.headers.common.Authorization = 'Bearer ' + token
  } else {
    try { delete api.defaults.headers.common.Authorization } catch (e) {}
  }
}

api.interceptors.request.use(function (config) {
  // If header already set by setAuthToken, keep it.
  // Otherwise, attach from localStorage for all requests.
  if (!config.headers || !config.headers.Authorization) {
    var t = getToken()
    if (t) {
      if (!config.headers) config.headers = {}
      config.headers.Authorization = 'Bearer ' + t
    }
  }
  return config
})

api.interceptors.response.use(
  function (r) { return r },
  function (err) {
    try {
      if (err && err.response && err.response.data) {
        err._eddaMsg = err.response.data.error || err.response.data.message || ''
      }
    } catch (e) {}
    return Promise.reject(err)
  }
)

export default api
